export enum HORIZONTAL_BANNER_SIZE {
  RESPONSIVE,
  SMALL,
}
